'use client'

import React, { useState } from 'react'
import Image from 'next/image'
import { usePathname } from 'next/navigation'
import { useSubscription } from '@/context/subscription-context/SubscriptionContext'
import TrialModal from '@/components/shared/TrialModal'
import { useCredits } from '@/context/credits-context/Credits-context'

interface TrialBannerProps {
  className?: string
}

export const TrialBanner: React.FC<TrialBannerProps> = ({ className = '' }) => {
  const [isTrialModalOpen, setIsTrialModalOpen] = useState(false)
  const { plan, isLoading } = useSubscription()
  const { creditsSummary } = useCredits()
  const pathname = usePathname()

  const shouldHideBanner = () => {
    const builderRoutePattern =
      /^\/subaccount\/[a-f0-9-]+\/landings\/[a-f0-9-]+\/builder\/[a-f0-9-]+$/
    const simpleBuilderRoute = pathname === '/builder'
    const paymentCheckoutRoute = /^\/agency\/[a-f0-9-]+\/payment-checkout$/
    return builderRoutePattern.test(pathname) || simpleBuilderRoute || paymentCheckoutRoute.test(pathname)
  }

  const isTrial = creditsSummary?.is_trial || plan?.toLowerCase() === 'trial'
  const daysRemaining = (() => {
    if (!creditsSummary?.next_charge_date) return 0

    const nextDate = new Date(creditsSummary.next_charge_date.replace(/(\d+)\s+(\w+),\s+(\d+)/, '$3-$2-$1'))
    const currentDate = new Date()

    const diffTime = nextDate.getTime() - currentDate.getTime()
    return Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24)))
  })()

  if (isLoading || !isTrial || shouldHideBanner()) return null

  return (
    <>
      <div className={`w-full bg-white py-2 text-center ${className}`} style={{ zIndex: 9999 }}>
        <div className="container h-10px flex items-center justify-center px-4" style={{ zIndex: 9999 }}>
          <div className="flex items-center justify-center gap-2">
            <Image
              src="/images/orange-AI.svg"
              alt="AI Icon"
              width={20}
              height={20}
              className="h-5 w-5"
            />
            <div className="flex items-center text-sm">
              <span className="font-bold text-black">{daysRemaining} Days Remaining in Your Trial.</span>
              <button
                onClick={() => setIsTrialModalOpen(true)}
                className="ml-1 cursor-pointer font-normal text-[#FF6434] hover:underline"
                style={{ color: "#FF6434" }}
              >
                Upgrade Now
              </button>
            </div>
          </div>
        </div>
      </div>

      <TrialModal
        open={isTrialModalOpen}
        onOpenChange={setIsTrialModalOpen}
        redirectURL={typeof window !== 'undefined' ? window.location.pathname : ''}
      />
    </>
  )
}

export default TrialBanner